import Image from 'next/image';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  padding: 42px 0 0 42px;
  display: flex;
  flex-direction: column;
  max-width: 1440px;
  width: 100%;
  height: 160px;
  background-color: #03095c;
  box-shadow: 4px 0px 20px 0px rgba(15, 24, 57, 0.2) inset;
  border-radius: 8px;
`;
export const Title = styled.h1`
  color: #f0f3f6;
  font-size: 32px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
`;
export const Description = styled.p`
  color: #d1d5db;
  font-size: 20px;
  line-height: 28px;
`;
export const BannerImage = styled(Image)`
  position: absolute;
  top: 0;
  right: 0;
`;
